export interface IErrorDto {
    ErrorCode: number;
    ErrorMessage: string;
}

export interface IValidationDto extends IErrorDto {
    Field: string;
}

export interface IResponseDto {
    Success: boolean;
    Error: IErrorDto | null;
    ValidationErrors: IValidationDto[];
}

export interface IDTO<T> extends IResponseDto {
    Data: T;
}

export interface ILoginErrorDto {
    error: string;
    // eslint-disable-next-line camelcase
    error_description: string;
}

export function isSame<T extends { Id: number }>(e1?: T, e2?: T) {
    return !!(
        !e1 && !e2 ||
        e1 && e2 && e1.Id === e2.Id);
}